import styled, { keyframes } from 'styled-components';

export interface IForwardIconProps {
  animated?: boolean;
}

export const pulseAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const IconContainer = styled.svg<IForwardIconProps>`
  path {
    animation: ${pulseAnimation} 1s infinite;
  }
  .item1 {
    animation-delay: 0.1s;
  }
  .item2 {
    animation-delay: 0.2s;
  }
  .item3 {
    animation-delay: 0.3s;
  }
  .item4 {
    animation-delay: 0.4s;
  }
  .item5 {
    animation-delay: 0.5s;
  }
`;

const ForwardIcon = ({ animated = false }: IForwardIconProps) => (
  <IconContainer
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 20 67"
    width="20"
    height="67"
    animated={animated}
  >
    <g>
      <path
        className="item0"
        d="M8.7,11.1c0.3,0.3,0.8,0.5,1.3,0.5s1-0.2,1.3-0.6L19,3.6c0.3-0.3,0.5-0.8,0.5-1.2c0-0.5-0.2-0.9-0.5-1.2c-0.7-0.7-1.9-0.7-2.6,0L10,7.3L3.6,1.1C2.9,0.4,1.7,0.4,1,1.1C0.7,1.4,0.5,1.9,0.5,2.3c0,0.5,0.2,0.9,0.5,1.2L8.7,11.1z"
        fill="#5496C6"
      />
      <path
        className="item1"
        d="M16.4,12.1L10,18.3l-6.4-6.2c-0.7-0.7-1.9-0.7-2.6,0c-0.3,0.3-0.5,0.8-0.5,1.2c0,0.5,0.2,0.9,0.5,1.2L8.7,22c0.3,0.3,0.8,0.5,1.3,0.5s1-0.2,1.3-0.6l7.6-7.4c0.3-0.3,0.5-0.8,0.5-1.2c0-0.5-0.2-0.9-0.5-1.2C18.3,11.4,17.1,11.4,16.4,12.1z"
        fill="#5496C6"
      />
      <path
        className="item2"
        d="M16.4,23.1L10,29.3l-6.4-6.2c-0.7-0.7-1.9-0.7-2.6,0c-0.3,0.3-0.5,0.8-0.5,1.2c0,0.5,0.2,0.9,0.5,1.2L8.7,33c0.4,0.3,0.8,0.5,1.3,0.5s0.9-0.2,1.3-0.5l7.7-7.5c0.3-0.3,0.5-0.8,0.5-1.2c0-0.5-0.2-0.9-0.5-1.2C18.3,22.4,17.1,22.4,16.4,23.1z"
        fill="#5496C6"
      />
      <path
        className="item3"
        d="M16.4,34.1L10,40.3l-6.4-6.2c-0.7-0.7-1.9-0.7-2.6,0c-0.3,0.3-0.5,0.8-0.5,1.2c0,0.5,0.2,0.9,0.5,1.2L8.7,44c0.4,0.3,0.8,0.5,1.3,0.5s0.9-0.2,1.3-0.5l7.7-7.5c0.3-0.3,0.5-0.8,0.5-1.2s-0.2-0.9-0.5-1.2C18.3,33.4,17.1,33.4,16.4,34.1z"
        fill="#5496C6"
      />
      <path
        className="item4"
        d="M16.4,45.1L10,51.3l-6.4-6.2c-0.7-0.7-1.9-0.7-2.6,0c-0.3,0.3-0.5,0.8-0.5,1.2c0,0.5,0.2,0.9,0.5,1.2L8.7,55c0.4,0.3,0.8,0.5,1.3,0.5s0.9-0.2,1.3-0.5l7.7-7.5c0.3-0.3,0.5-0.8,0.5-1.2s-0.2-0.9-0.5-1.2C18.3,44.4,17.1,44.4,16.4,45.1z"
        fill="#5496C6"
      />
      <path
        className="item5"
        d="M16.4,56.1L10,62.3l-6.4-6.2c-0.7-0.7-1.9-0.7-2.6,0c-0.3,0.3-0.5,0.8-0.5,1.2c0,0.5,0.2,0.9,0.5,1.2L8.7,66c0.4,0.3,0.8,0.5,1.3,0.5s0.9-0.2,1.3-0.5l7.7-7.5c0.3-0.3,0.5-0.8,0.5-1.2s-0.2-0.9-0.5-1.2C18.3,55.4,17.1,55.4,16.4,56.1z"
        fill="#5496C6"
      />
    </g>
  </IconContainer>
);

export default ForwardIcon;
